import React, { Component } from "react";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import crStyles from "../../../customerReservation/crStyles";
import styles from "../OrderDetailsNewVersion.module.scss";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SpecsRow from "../SpecsRow";
import { withTranslation } from "react-i18next";
import { formatEUPriceValue } from "../../../../utils/FormatPrice";
import { IS_ITALY_MARKET } from "../../../../utils/EmpUtil";

class FinanceBreakdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandFinanceQuote: false,
      expandCharging: false,
      expandAccessories: false,
      itemsNotIncludedOnQuoteExpansion: false,
      expandItemsNotIncludedAccessories: false,
      expandItemsNotIncludedCharging: false,
      expandProtectionPlans: false,
    };
    this.distanceUnit =
      this.props.localizedInfo && this.props.localizedInfo.defaultDistanceUnit
        ? "/".concat(this.props.localizedInfo.defaultDistanceUnit)
        : "";
  }

  expandProtectionPlans() {
    this.setState((prevState) => ({
      expandProtectionPlans: !prevState.expandProtectionPlans,
    }));
  }

  expandItemsNotIncludedCharging() {
    this.setState((prevState) => ({
      expandItemsNotIncludedCharging: !prevState.expandItemsNotIncludedCharging,
    }));
  }

  expandItemsNotIncludedAccessories() {
    this.setState((prevState) => ({
      expandItemsNotIncludedAccessories:
        !prevState.expandItemsNotIncludedAccessories,
    }));
  }

  expandAccessories() {
    this.setState((prevState) => ({
      expandAccessories: !prevState.expandAccessories,
    }));
  }

  expandCharging() {
    this.setState((prevState) => ({
      expandCharging: !prevState.expandCharging,
    }));
  }

  expandFinanceQuote() {
    this.setState((prevState) => ({
      expandFinanceQuote: !prevState.expandFinanceQuote,
    }));
  }

  itemsNotIncludedOnQuoteExpansion() {
    this.setState((prevState) => ({
      itemsNotIncludedOnQuoteExpansion:
        !prevState.itemsNotIncludedOnQuoteExpansion,
    }));
  }

  render() {
    const pricingStackData = this.props.customerReservation.pricingStack;
    const financeDataQuote = this.props.customerReservation.financeDataQuote;
    const protectionPlansData =
      this.props.customerReservation.protectionPlansData;
    const defaultCurrency = this.props.defaultCurrency;
    const tradeInDetails = this.props.tradeInDetails;

    function formatPriceValue(value) {
      return formatEUPriceValue(value, defaultCurrency);
    }

    return (
      <div>
        <StyledBasicExpansionPanel
          expanded={this.state.expandFinanceQuote}
          disabled={false}
          onChange={() => this.expandFinanceQuote()}
          data-testid="financeExpansionPanel"
        >
          <StyledBasicExpansionPanelSummary
            style={crStyles.orderDetailsExpansion}
            id="financeExpansionSummary"
          >
            <div className={styles.headerBar}>
              <div className={styles.header}>
                {this.props.t("FinanceBreakdown.title")}
              </div>
              <div>
                {this.state.expandFinanceQuote ? (
                  <ExpandLessIcon data-testid="lessFinanceQuote" />
                ) : (
                  <ExpandMoreIcon data-testid="moreFinanceQuote" />
                )}
              </div>
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>

          {financeDataQuote ? (
            <div>
              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.monthlyPayment")}
                price={formatPriceValue(
                  financeDataQuote.monthlyPaymentWithoutInclusiveFee
                )}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.numberOfMonthlyPayments"
                )}
                price={financeDataQuote.numberOfPayments}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.dealerOTRPromotionalPrice"
                )}
                price={formatPriceValue(
                  this.props.selectedMarket.toUpperCase() === "FRA"
                    ? pricingStackData.totalVehiclePriceWithSavings
                    : pricingStackData.promotionalDealerPrice
                )}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />

              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.priceAdjustments")}
                price={formatPriceValue(pricingStackData.dealerAdjustmentPrice)}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />

              {pricingStackData.chargingAccessoriesData && (
                <StyledBasicExpansionPanel
                  expanded={this.state.expandCharging}
                  disabled={false}
                  onChange={() => this.expandCharging()}
                  data-testid="chargingExpansionPanel"
                >
                  <StyledBasicExpansionPanelSummary
                    style={crStyles.headerBarBg}
                    id="chargingExpansionSummary"
                  >
                    <SpecsRow
                      priceDetails={this.props.t("FinanceBreakdown.charging")}
                      price={formatPriceValue(
                        pricingStackData.chargingPriceTotal
                      )}
                      style={`${styles.darkCaseSensitiveHeader} ${styles.smallRightIndent}  ${styles.rightAlign}`}
                      rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                    />
                    <div className={styles.darkCaseSensitiveHeader}>
                      {this.state.expandCharging ? (
                        <ExpandLessIcon data-testid="lessCharging" />
                      ) : (
                        <ExpandMoreIcon data-testid="moreCharging" />
                      )}
                    </div>
                  </StyledBasicExpansionPanelSummary>

                  {pricingStackData.chargingAccessoriesData.chargingList
                    .length > 0 &&
                    pricingStackData.chargingAccessoriesData.chargingList.map(
                      (chargingOption, index) => {
                        return (
                          <SpecsRow
                            priceDetails={chargingOption.shortDescription}
                            price={formatPriceValue(
                              chargingOption.dealerSellingPrice
                            )}
                            style={`${styles.darkCaseSensitiveHeader} ${styles.rightIndent}  ${styles.rightAlign}`}
                            rowStyle={`${styles.largeIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                            key={index}
                          />
                        );
                      }
                    )}
                </StyledBasicExpansionPanel>
              )}
              {pricingStackData.chargingAccessoriesData && (
                <StyledBasicExpansionPanel
                  expanded={this.state.expandAccessories}
                  disabled={false}
                  onChange={() => this.expandAccessories()}
                  data-testid="accessoriesExpansionPanel"
                >
                  <StyledBasicExpansionPanelSummary
                    style={crStyles.barBg}
                    id="accessoriesExpansionSummary"
                  >
                    <SpecsRow
                      priceDetails={this.props.t(
                        "FinanceBreakdown.accessoriesTitle"
                      )}
                      price={formatPriceValue(
                        pricingStackData.accessoriesPriceTotal
                      )}
                      style={`${styles.lightCaseSensitiveHeader} ${styles.smallRightIndent}  ${styles.rightAlign}`}
                      rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                    />
                    <div className={styles.lightCaseSensitiveHeader}>
                      {this.state.expandAccessories ? (
                        <ExpandLessIcon data-testid="lessAccessories" />
                      ) : (
                        <ExpandMoreIcon data-testid="moreAccessories" />
                      )}
                    </div>
                  </StyledBasicExpansionPanelSummary>

                  {pricingStackData.chargingAccessoriesData.accessoriesList
                    .length > 0 &&
                    pricingStackData.chargingAccessoriesData.accessoriesList.map(
                      (accessoriesOption, index) => {
                        return (
                          <SpecsRow
                            priceDetails={accessoriesOption.shortDescription}
                            price={formatPriceValue(
                              accessoriesOption.dealerSellingPrice
                            )}
                            style={`${styles.lightCaseSensitiveHeader} ${styles.rightIndent}  ${styles.rightAlign}`}
                            rowStyle={`${styles.largeIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                            key={index}
                          />
                        );
                      }
                    )}
                </StyledBasicExpansionPanel>
              )}

              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.customerDeposit")}
                price={formatPriceValue(financeDataQuote.deposit)}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
                dataTestId="customerDeposit"
              />
              {tradeInDetails && tradeInDetails.applyFinanceForTradeIn && (
                <SpecsRow
                  priceDetails={this.props.t(
                    "FinanceBreakdown.tradeInValuation"
                  )}
                  price={formatPriceValue(pricingStackData.tradeInPrice)}
                  style={styles.lightCaseSensitiveHeader}
                  rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
                />
              )}

              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.depositAllowance")}
                price={formatPriceValue(financeDataQuote.depositAllowance)}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.amountOfCredit")}
                price={formatPriceValue(
                  financeDataQuote.totalAmountFinancedStandard
                )}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.interestChargesAndFees"
                )}
                price={formatPriceValue(financeDataQuote.creditCost)}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.fees")}
                price={formatPriceValue(financeDataQuote.fees)}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.optionalFinalPayment"
                )}
                price={formatPriceValue(financeDataQuote.optionalFinalPayment)}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.totalAmountPayable"
                )}
                price={formatPriceValue(
                  IS_ITALY_MARKET(this.props.selectedMarket)
                    ? financeDataQuote.totalAmountRepaid
                    : financeDataQuote.totalAmountPayable
                )}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.fixedBorrowingRate"
                )}
                price={
                  financeDataQuote.borrowingRate === null
                    ? "--"
                    : financeDataQuote.borrowingRate + "%"
                }
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.aprRepresentative"
                )}
                price={
                  financeDataQuote.apr === null
                    ? "--"
                    : financeDataQuote.apr + "%"
                }
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.annualMileage")}
                price={
                  financeDataQuote.annualMileage
                    ? financeDataQuote.annualMileage
                    : "--"
                }
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakdown.excessMileageCharge"
                )}
                price={
                  financeDataQuote.excessMileageCharge === null ||
                  financeDataQuote.excessMileageCharge === undefined
                    ? "--"
                    : financeDataQuote.excessMileageCharge
                        .toString()
                        .concat("p")
                        .concat(this.distanceUnit)
                }
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
            </div>
          ) : null}
        </StyledBasicExpansionPanel>

        <StyledBasicExpansionPanel
          expanded={this.state.itemsNotIncludedOnQuoteExpansion}
          disabled={false}
          onChange={() => this.itemsNotIncludedOnQuoteExpansion()}
          data-testid="itemsNotIncludedExpansionPanel"
        >
          <StyledBasicExpansionPanelSummary
            style={crStyles.orderDetailsExpansion}
            data-testid="itemsNotIncludedExpansionSummary"
          >
            <div className={styles.headerBar}>
              <div className={styles.header}>
                {this.props.t("ItemsNotIncludedOnQuote.title")}
              </div>
              <div>
                {this.state.itemsNotIncludedOnQuoteExpansion ? (
                  <ExpandLessIcon data-testid="lessItemsNotIncluded" />
                ) : (
                  <ExpandMoreIcon data-testid="moreItemsNotIncluded" />
                )}
              </div>
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>

          {financeDataQuote ? (
            <div>
              <SpecsRow
                priceDetails={this.props.t(
                  "ItemsNotIncludedOnQuote.financeDeposit"
                )}
                price={formatPriceValue(financeDataQuote.deposit)}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
                dataTestId="financeDeposit"
              />

              <StyledBasicExpansionPanel
                expanded={this.state.expandItemsNotIncludedAccessories}
                disabled={false}
                onChange={() => this.expandItemsNotIncludedAccessories()}
                data-testid="financeItemsNotIncludedAccessoriesPanel"
              >
                <StyledBasicExpansionPanelSummary
                  style={crStyles.headerBarBg}
                  id="financeItemsNotIncludedAccessoriesSummary"
                >
                  <SpecsRow
                    priceDetails={this.props.t(
                      "ItemsNotIncludedOnQuote.accessories"
                    )}
                    price={formatPriceValue(
                      pricingStackData.accessoriesPriceTotal
                    )}
                    style={`${styles.darkCaseSensitiveHeader} ${styles.smallRightIndent}  ${styles.rightAlign}`}
                    rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                  />
                  <div className={styles.darkCaseSensitiveHeader}>
                    {this.state.expandItemsNotIncludedAccessories ? (
                      <ExpandLessIcon data-testid="lessItemsNotIncludedAccessories" />
                    ) : (
                      <ExpandMoreIcon data-testid="moreItemsNotIncludedAccessories" />
                    )}
                  </div>
                </StyledBasicExpansionPanelSummary>

                {pricingStackData.chargingAccessoriesData.accessoriesList
                  .length > 0 &&
                  pricingStackData.chargingAccessoriesData.accessoriesList.map(
                    (accessoriesOption, index) => {
                      return (
                        <SpecsRow
                          priceDetails={accessoriesOption.shortDescription}
                          price={formatPriceValue(
                            accessoriesOption.dealerSellingPrice
                          )}
                          style={`${styles.lightCaseSensitiveHeader} ${styles.rightIndent}  ${styles.rightAlign}`}
                          rowStyle={`${styles.largeIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                          key={index}
                        />
                      );
                    }
                  )}
              </StyledBasicExpansionPanel>

              {pricingStackData.chargingAccessoriesData && (
                <StyledBasicExpansionPanel
                  expanded={this.state.expandItemsNotIncludedCharging}
                  disabled={false}
                  onChange={() => this.expandItemsNotIncludedCharging()}
                  data-testid="financeItemsNotIncludedChargingPanel"
                >
                  <StyledBasicExpansionPanelSummary
                    style={crStyles.barBg}
                    id="financeItemsNotIncludedChargingSummary"
                  >
                    <SpecsRow
                      priceDetails={this.props.t(
                        "ItemsNotIncludedOnQuote.charging"
                      )}
                      price={formatPriceValue(
                        pricingStackData.chargingPriceTotal
                      )}
                      style={`${styles.lightCaseSensitiveHeader} ${styles.smallRightIndent}  ${styles.rightAlign}`}
                      rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                    />
                    <div className={styles.lightCaseSensitiveHeader}>
                      {this.state.expandItemsNotIncludedCharging ? (
                        <ExpandLessIcon data-testid="lessItemsNotIncludedCharging" />
                      ) : (
                        <ExpandMoreIcon data-testid="moreItemsNotIncludedCharging" />
                      )}
                    </div>
                  </StyledBasicExpansionPanelSummary>

                  {pricingStackData.chargingAccessoriesData.chargingList
                    .length > 0 &&
                    pricingStackData.chargingAccessoriesData.chargingList.map(
                      (chargingOption, index) => {
                        return (
                          <SpecsRow
                            priceDetails={chargingOption.shortDescription}
                            price={formatPriceValue(
                              chargingOption.dealerSellingPrice
                            )}
                            style={`${styles.darkCaseSensitiveHeader} ${styles.rightIndent}  ${styles.rightAlign}`}
                            rowStyle={`${styles.largeIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                            key={index}
                          />
                        );
                      }
                    )}
                </StyledBasicExpansionPanel>
              )}

              {protectionPlansData && protectionPlansData.protectionPlans && (
                <StyledBasicExpansionPanel
                  expanded={this.state.expandProtectionPlans}
                  disabled={false}
                  onChange={() => this.expandProtectionPlans()}
                  data-testid="financeProtectionPlansPanel"
                >
                  <StyledBasicExpansionPanelSummary
                    style={crStyles.barBg}
                    id="financeProtectionPlansSummary"
                  >
                    <SpecsRow
                      priceDetails={this.props.t(
                        "ItemsNotIncludedOnQuote.protectionPlans"
                      )}
                      price={formatPriceValue(protectionPlansData.totalPrice)}
                      style={`${styles.darkCaseSensitiveHeader} ${styles.smallRightIndent}  ${styles.rightAlign}`}
                      rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                    />
                    <div className={styles.darkCaseSensitiveHeader}>
                      {this.state.expandProtectionPlans ? (
                        <ExpandLessIcon data-testid="lessProtectionPlans" />
                      ) : (
                        <ExpandMoreIcon data-testid="moreProtectionPlans" />
                      )}
                    </div>
                  </StyledBasicExpansionPanelSummary>

                  {protectionPlansData.protectionPlans.length > 0 &&
                    protectionPlansData.protectionPlans.map(
                      (protectionPlan, index) => {
                        return (
                          <SpecsRow
                            priceDetails={protectionPlan.planName}
                            price={formatPriceValue(
                              protectionPlan.dealerSellingPrice
                            )}
                            style={`${styles.darkCaseSensitiveHeader} ${styles.rightIndent}  ${styles.rightAlign}`}
                            rowStyle={`${styles.largeIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                            key={index}
                          />
                        );
                      }
                    )}
                </StyledBasicExpansionPanel>
              )}

              {tradeInDetails && !tradeInDetails.applyFinanceForTradeIn && (
                <SpecsRow
                  priceDetails={this.props.t("FinanceBreakdown.tradeIn")}
                  price={formatPriceValue(-1 * pricingStackData.tradeInPrice)}
                  style={`${styles.darkCaseSensitiveHeader} ${styles.rightIndent} ${styles.rightAlign}`}
                  rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
                />
              )}
              <SpecsRow
                priceDetails={this.props.t("FinanceBreakdown.balanceOnOrder")}
                price={formatPriceValue(pricingStackData.totalAmountPayable)}
                dataTestId="balanceOnOrder"
                style={`${styles.lightCaseSensitiveHeader} ${styles.boldHeader}`}
              />
            </div>
          ) : null}
        </StyledBasicExpansionPanel>
      </div>
    );
  }
}

export default withTranslation("emp")(FinanceBreakdown);
